export const TOAST_TYPES = {
    INFO: "info",
    WARNING: "warning",
    ERROR: "error",
    SUCCESS: "success",
    DEFAULT: "default",
}
